export default from './category-list';



// WEBPACK FOOTER //
// ./app/components/category-list/index.js